import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgClass } from '@angular/common';
import { ValidationFormComponent } from '../validation-form/validation-form.component';
import { NoLeadingSpaceDirective } from '@core-utils';

@Component({
  selector: 'ui-form-textarea',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    ValidationFormComponent,
    NoLeadingSpaceDirective,
  ],
  templateUrl: './form-textarea.component.html',
  styleUrl: './form-textarea.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormTextareaComponent {
  dataCy = input<string>('');
  control = input<AbstractControl>();
  global = input<boolean>(true);
  readOnly = input<boolean>(false);
  placeholder = input<string>('');
  value = input<string | number>('');
  skipValidation = input<boolean>(false);
  description = input<string>('');

  get formControl(): FormControl {
    return this.control() as FormControl;
  }
}
